(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerWrapper = document.querySelector('.header-wrapper.color-scheme-1.gradient');
    this.icons = this.headerWrapper.querySelectorAll('.header__icon'); // Your icon selector
    this.logo = this.headerWrapper.querySelector('.logo-class'); // Your logo selector
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
      this.updateHeaderStyles(); // Apply initial styles
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      this.updateHeaderStyles();
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
      this.updateHeaderStyles();
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      this.updateHeaderStyles();
    }

    this.currentScrollTop = scrollTop;
  }

  updateHeaderStyles() {
    const currentURL = window.location.href;
    const validURLs = [
      'https://z9kwea-b8.myshopify.com',
      'https://z9kwea-b8.myshopify.com/',
      'https://z9kwea-b8.myshopify.com/?customer_posted=true#ContactFooter',
    ];

    if (this.header.classList.contains('scrolled-past-header')) {
      // Scrolled state: white background, black icons, logo default state
      this.headerWrapper.style.backgroundColor = 'white';
      this.headerWrapper.style.boxShadow = '0 1px 0 rgba(0, 0, 0, 0.1)'; // Smooth border to avoid white line

      // Change icon colors only for valid URLs
      if (validURLs.includes(currentURL)) {
        this.updateIconColors('black'); // Black icons when scrolled
      }

      this.updateLogoFilter('invert(0)');
    } else {
      // Transparent state: transparent background, white icons, logo inverted
      this.headerWrapper.style.backgroundColor = 'transparent';
      this.headerWrapper.style.boxShadow = 'none';

      // Change icon colors only for valid URLs
      if (validURLs.includes(currentURL)) {
        this.updateIconColors('white'); // White icons initially
      }

      this.updateLogoFilter('invert(1)');
    }
  }

  updateIconColors(color) {
    this.icons.forEach((icon) => {
      icon.style.color = color;
    });
  }

  updateLogoFilter(filter) {
    if (this.logo) {
      this.logo.style.filter = filter;
    }
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
